import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Final from "../assets/Header&Footer/onsites.png";
import PlayStore from "../assets/Header&Footer/app-store-google.png";
import bgImage from "../assets/Header&Footer/headerbg.jpg";
import AppStore from "../assets/Header&Footer/app-store-apple.png";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);

  return (
    <footer
      className="text-white bg-white py-10 px-4 md:px-8"
      style={{
        backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
      }}
    >

       {/* Modal Overlay 1 */}
       {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

          {/* Big Modal Content */}
          <div className="bg-white rounded-lg shadow-lg p-8 w-[70%] h-[100%]  overflow-auto">
           <div className="bg-gray-50 min-h-screen py-10 px-6">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Privacy Policy
        </h1>

        {/* Intro */}
        <p className="text-gray-600 mb-6">
          This Privacy Policy covers the Company’s policy of personally
          identifiable information that the Company accumulates when the User
          is on the Company’s website and mobile application under the name
          <span className="font-semibold"> FillNow</span>, and when the User
          uses the Company’s services.
        </p>

        {/* Section 1 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          1. Definitions
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li><span className="font-semibold">Applicable Law:</span> includes all relevant statutes and regulations.</li>
          <li><span className="font-semibold">Cookie:</span> small text file placed on device to enable features.</li>
          <li><span className="font-semibold">Non-Aggregated Personal Information:</span> personally identifiable data provided to the Company.</li>
          <li><span className="font-semibold">User:</span> any end user of FillNow app or website.</li>
        </ul>

        {/* Section 2 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          2. Interpretation
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>Singular includes plural and vice versa.</li>
          <li>Masculine includes feminine and neutral.</li>
          <li>“Including” means “including, without limitation.”</li>
        </ul>

        {/* Section 3 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          3. Terms
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>Protecting privacy and confidentiality is a priority.</li>
          <li>Cookies are used (essential and non-essential) to enhance functionality and analyze usage.</li>
          <li>Collected information includes user activity, device details, and usage reports.</li>
          <li>Information is used to improve services, communicate efficiently, promote safety, and provide offers.</li>
        </ul>

        {/* Section 4 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          4. Data Analytics
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>User identity and information will be kept confidential and used for research, marketing, and strategic analysis.</li>
          <li>Email and text communications may include account updates, policy changes, promotions, and newsletters (opt-out available).</li>
          <li>Company may partner with other vendors to offer combined services, clearly disclosing partners.</li>
          <li>Aggregate demographic information may be shared with advertisers, but personal data is not shared unless required.</li>
        </ul>

        {/* Section 5 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          5. Accessing and Changing Account Information
        </h2>
        <p className="text-gray-600">
          Users can review and update personal information anytime by logging into their account and editing profile settings.
        </p>

        {/* Section 6 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          6. Security
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>Company works to protect against unauthorized access, alteration, or disclosure.</li>
          <li>Information collection and storage practices are regularly reviewed.</li>
          <li>Access to personal data is restricted to authorized personnel under strict confidentiality obligations.</li>
        </ul>

        {/* Section 7 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          7. Consent
        </h2>
        <p className="text-gray-600">
          User consent will be obtained before using information for purposes beyond those set out in this Policy.
        </p>

        {/* Section 8 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          8. Limitation
        </h2>
        <p className="text-gray-600">
          This Policy does not apply to services offered by other companies or individuals, including linked sites or advertisers.
        </p>

        {/* Section 9 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          9. Applicable Terms of Use
        </h2>
        <p className="text-gray-600">
          Terms of the corresponding Terms of Use on <span className="font-semibold">www.fillnow.in</span> apply mutatis mutandis to this Policy.
        </p>

        {/* Section 10 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          10. Permissions
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li><span className="font-semibold">Storage:</span> Allows local caching to reduce network calls and improve performance.</li>
          <li><span className="font-semibold">Network Communication:</span> Enables secure, encrypted data transfer between device and servers.</li>
          <li><span className="font-semibold">Receive and Read SMS:</span> Used for OTP auto-reading and personalized offers.</li>
          <li><span className="font-semibold">Location:</span> Helps display nearby service providers (Bowsers).</li>
        </ul>
      </div>
    </div>


            <div className="flex justify-center mt-6">
  <button
    onClick={() => setIsOpen(false)}
    className="px-4 py-2 bg-yellow-600 text-white rounded hover:bg-blue-700"
  >
    Close
  </button>
</div>
          </div>
        </div>
      )}
      {/* Modal Overlay 2 */}
       {isOpen2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

          {/* Big Modal Content */}
          <div className="bg-white rounded-lg shadow-lg p-8 w-[70%] h-[100%]  overflow-auto">
           <div className="bg-gray-50 min-h-screen py-10 px-6">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Shipping Policy
        </h1>

       
       

        {/* Section 1 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          1. What are the delivery charges?
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>Delivery charge varies with each Seller.</li>
          <li>Sellers incur relatively higher shipping costs on low value items. In such cases, charging a nominal delivery charge helps them offset logistics costs. Please check your order summary to understand the delivery charges for individual products.</li>
         
        </ul>

        {/* Section 2 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          2. What is the estimated delivery time?
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>Sellers generally procure and ship the items within the time specified on the product page. Business days exclude public holidays and Sundays</li>
          <li><span className="font-semibold">Estimated delivery time depends on the following factors:</span>
            <ul className="list-disc pl-6 space-y-2 text-gray-600"><li>The Seller offering the product.</li>
              <li>Product's availability with the Seller.</li>
              <li>The destination to which you want the order shipped to and location of the Seller.</li>

              </ul>
          </li>
        </ul>

        {/* Section 3 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          3. Are there any hidden costs (sales tax, octroi etc) on items sold by Sellers on Synergy?
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>There are NO hidden charges when you make a purchase on Synergy. List prices are final and all-inclusive. The price you see on the product page is exactly what you would pay.</li>
          
        </ul>

        {/* Section 4 */}
        <h2 className="text-2xl font-semibold text-gray-700 mt-8 mb-4">
          4. Delivery charges are not hidden charges and are charged (if at all) extra depending on the Seller's shipping policy.
        </h2>
        
       

        
      </div>
    </div>


            <div className="flex justify-center mt-6">
  <button
    onClick={() => setIsOpen2(false)}
    className="px-4 py-2 bg-yellow-600 text-white rounded hover:bg-blue-700"
  >
    Close
  </button>
</div>
          </div>
        </div>
      )}
      {/* Modal Overlay 3 */}
       {isOpen3 && (
       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  {/* Modal Content */}
  <div className="bg-white rounded-lg shadow-xlw-[70%] h-[100%]  overflow-hidden flex flex-col">
    
    {/* Scrollable Body */}
    <div className="flex-1 overflow-y-auto p-8">
      <div className="bg-gray-50 min-h-screen py-10 px-6">
        <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
          
          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-800 mb-6">
            How do returns work?
          </h1>

          {/* Intro */}
          <p className="text-gray-600 mb-6">
            You can raise a request to return your items with these simple steps:
          </p>

          {/* Steps */}
          <ol className="list-decimal pl-6 space-y-2 text-gray-600">
            <li>Log into your <span className="font-semibold">Synergy</span> account.</li>
            <li>Go to <span className="font-semibold">My Orders</span>.</li>
            <li>Click on <span className="font-semibold">'Cancel'</span> against the item you wish to cancel.</li>
          </ol>

          {/* Process Explanation */}
          <p className="text-gray-600 mt-6">
            Once you raise a request, you'll get an email and SMS confirming that your request is being processed. 
            Based on the item, your request may be automatically approved or you may be contacted for more details. 
            If the request is approved, the item will be cancelled after which you will get a refund.
          </p>

          {/* Refund Timeline */}
          <p className="text-gray-600 mt-6">
            Once the refund is approved, your payment will be credited back within 
            <span className="font-semibold"> 5-7 working days </span> to the same account from which it was debited. 
            However, if you opt to credit to your wallet, the same will be done 
            <span className="font-semibold"> immediately after approval</span>.
          </p>
        </div>
      </div>
    </div>

    {/* Footer with Close Button */}
    <div className="flex justify-center p-4 border-t bg-gray-50">
      <button
        onClick={() => setIsOpen3(false)}
        className="px-6 py-2 bg-yellow-600 text-white rounded-lg font-medium hover:bg-yellow-700 transition-colors"
      >
        Close
      </button>
    </div>
  </div>
</div>
      )}
      {/* Modal Overlay 4 */}
       {isOpen4 && (
       <div
  className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  role="dialog"
  aria-modal="true"
  aria-labelledby="terms-title"
>
  <div className="bg-white rounded-lg shadow-xl w-[70%] h-[100%] flex flex-col overflow-hidden">
    
    {/* Scrollable Body */}
    <div className="flex-1 overflow-y-auto p-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        
        {/* Title */}
        <h1 id="terms-title" className="text-3xl font-bold text-gray-800 mb-6">
          TERMS OF USE
        </h1>

        {/* Intro */}
        <p className="text-gray-600 mb-6">
          This Terms of Use is entered into by and between 
          <span className="font-semibold"> Synergy Teletech Private Limited </span> 
          (hereinafter referred to as the “Company”) and the Customer. 
          The Company and the Customer shall hereinafter be individually referred to as a “Party” 
          and collectively referred to as the “Parties”, as the context may require.
        </p>

        {/* WHEREAS Section */}
        <h2 className="text-xl font-semibold text-gray-700 mb-4">WHEREAS:</h2>
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
          <li>The Company is engaged in the business of sale and delivery of Biodiesel, branded as <span className="font-semibold">Synergy Green Diesel</span>, and/or aggregating demand for delivery of HSD (High Speed Diesel) to customers through its franchisee network via its mobile application (hereinafter referred to as the “App”).</li>
          <li>The Customer is the buyer of the Purchased Items for personal consumption.</li>
          <li>The Parties are desirous to enter this Terms of Use.</li>
          <li>In consideration of the mutual promises, covenants, and agreements, the Parties hereby enter into this Terms of Use on the terms and conditions contained herein.</li>
        </ol>

        {/* Definitions Section */}
       

        {/* Customer Representations */}
        <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          1. DEFINITIONS AND INTERPRETATIONS AND OVERRIDING EFFECT :
        </h2>
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
          <li>The Customer shall not engage in resale or commercial exploitation of Purchased Items.</li>
         
        <li>
 <span className="font-semibold">Definitions:</span> The Parties to this Terms of Use hereby unconditionally agree that unless the context otherwise requires, the terms listed below when used in this Terms of Use shall have the meanings attached to them and these terms shall be interpreted accordingly. The terms listed below as used in this Terms of Use may be identified by the capitalization of the first letter of each principal word thereof. In addition to the terms defined below, certain other capitalized terms are defined elsewhere in this Terms of Use and whenever such terms are used in this Terms of Use they shall have their respective defined meanings, unless the context, expressly or by necessary implication, require otherwise.</li>
        <li>
  <span className="font-semibold">“Applicable Law” </span>includes all applicable statutes, enactments, acts of state legislatures or parliament, laws, ordinances, rules, bye-laws, regulations, notifications, guidelines, policies, directions, directives and orders of any governmental authority, statutory authority, tribunal, board, court or recognized stock exchange of any relevant jurisdiction.</li>
        <li>
  <span className="font-semibold">“Definitive Documentation” </span> includes this Terms of Use, as well as the corresponding Privacy Policy and the Fuel Quality Agreement.</li>
        <li>
  <span className="font-semibold">“Delivery Stage” </span>   shall mean the stage when the Order out for the delivery to the Customer.</li>
        <li>
  <span className="font-semibold"> “Event of Default”</span>   shall mean the breach of any and all clauses of this Agreement by the Customer.</li>
        <li>
  <span className="font-semibold">“Indemnified Liabilities” </span>   shall have the meaning ascribed to it in Clause 5</li>
        <li>
  <span className="font-semibold">“Order” </span>  shall include any purchase made by the Customer on the App.</li>
        <li>
  <span className="font-semibold">“Person”</span>   means and includes an individual, a sole proprietorship, an association, syndicate, a corporation, a firm, a partnership, a joint venture, a trust, an unincorporated organization, a joint stock company, a limited liability company or other entity or organization, body corporate, governmental authority, judicial authority, a natural person in his capacity as trustee, executor, administrator, or other legal representative and any other entity including a government or political subdivision, or an agency or instrumentality thereof and/or any other legal entity.</li>
        <li>
  <span className="font-semibold"> “Purchased Items” </span> shall mean the products purchased by the Customer from the Company using the App</li>
        <li>
  <span className="font-semibold">“Third Party”</span>   shall mean any Persons other than the Parties and the term “Third Parties” shall be construed accordingly.</li>
        <li>
  In this Terms of Use, except to the extent that the context otherwise requires:</li>


   <li>References to a statute, ordinance or other Law shall be deemed to include any references to a statute, ordinance or other Law as amended, supplemented or replaced from time to time in accordance with its terms and (where applicable) subject to compliance with the requirements set forth therein and shall include regulations and other instruments under such statue, ordinance or other Law.</li>
<li> References to Clauses, are reference to clauses in this Terms of Use unless the context requires otherwise and the recitals to this Terms of Use shall always be deemed to form part of this Terms of Use.</li>
<li> The headings are inserted for convenience only and shall not affect the construction of this Terms of Use. </li>
<li> The masculine gender includes the feminine gender and vice versa</li>

 </ol>

 <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          2. REPRESENTATIONS, WARRANTIES, DECLARATIONS AND COVENANTS BY THE CUSTOMER :
        </h2>
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
          <li>The Customer represents and warrants that he shall not engage in any transaction directly and indirectly using the App for any commercial purpose that shall involve resale and/or direct commercial exploitation of the Purchased Items.</li>
          <li>The Customer specifically covenants that he shall not resell any and all of the Purchased Items in any manner whatsoever.</li>
          <li>The Customer understands and acknowledges that any and all information provided through the App by the Company is on an “as-is-as-available” basis. </li>


           <li> The Company periodically provides certain promotional discounts in relation to the App and the Company reserves the right at any time to amend and/or otherwise remove such promotional offers in relation to the Items being sold through the App.
</li><li> The Customer specifically covenants that he shall partake directly and/or otherwise assist any third person in unauthorised rebranding and/or relabelling of all of the Purchased Items.
</li><li> The Customer represents and warrants that all information provided by him to the App and/or Company are true and accurate.
</li><li> Notwithstanding anything contained herein and or any connection that the Company may have with any arrangement and/or agreement that are entered pursuant thereto, the Customer specifically represents and warrants that he is not prohibited, in any manner whatsoever, either directly and/or indirectly, to avail any of the services (including but not limited to purchase of the Purchased Item) that have been made available to him by the Company and/or any third party through this Terms of Use.
</li><li> Notwithstanding anything contained herein and or any connection that the Company may have with any arrangement and/or agreement that are entered pursuant thereto, the Customer covenants that he shall not make use of the App, been made available to him by the Company and/or any third party through this Terms of Use, for a purpose that is prohibited under Applicable Law.
</li><li> The Customer covenants that he shall not upload viruses or other malicious code to the App and/or any other computer system connected thereto.
</li><li> The Customer shall not solicit login information or access an account belonging to any Third Party.
</li><li> The Customer shall not do anything that could disable, overburden, or impair the proper working or appearance of the App, and/are any part thereof and/or services connected thereto, such as a denial of service attack or interference with page rendering or other aspects of operational functionality.
</li><li> The Customer shall not facilitate and/or encourage any violations of this Terms of Use or any of the policies of the Company.
</li><li> The Customer shall not provide any false personal information on the App and/or any other computer system connected thereto, or creates an account for any Third Party other than himself/herself without permission of that Third Party as well as the Company, respectively.
</li><li> The Customer shall not create more than one account for the App.
</li><li> The Customer shall not create another account on the App after the Company disables his/her account, without the permission of the Company.
</li><li> The Customer specifically covenants that the contact information of the Customer and always be accurate and up to date.
</li><li> The Customer shall not share his password, let anyone else access his account, and/or do anything else that might jeopardize the security of his account with the App and/or any computer system connected thereto.
</li><li> The Customer shall not make any attempts to interfere with or disrupt the App, and/or any service/computer systems/networks connected thereto.
</li><li> The Customer shall not take any action that imposes an unreasonable or disproportionately large load on the infrastructure of the App and/or the computer systems connected thereto;
</li><li> The Customer shall not copy, reproduce, alter, modify, and/or publicly display any information displayed on the App, or create derivative works from the App, to the extent that such action(s) would constitute copyright infringement or otherwise violate the intellectual property rights of the Company or any other Third Party, except with the prior written consent of Company or the appropriate Third Party.
</li><li> The Customer shall not take any action which is intended, or would reasonably be expected, to harm the Company or its or their reputation or which would reasonably be expected to lead to unwanted or unfavourable publicity to the Company.
</li><li> The Customer specifically covenants that he shall not use the Purchased Items and/or any part thereof for any form of direct commercial use whatsoever, including but not limited to advertisements, fuel logistics, etc. without the prior written permission of the Company.
</li><li> The Customer specifically represents, warrants and covenants that all information provided by him to the Company are complete and accurate.
</li><li> The Customer specifically covenants that all information requisitioned by the Company shall be provided in a timely and professional manner as well as being complete and accurate.
</li><li> The customer authorises the company to collect payment for product delivered on behalf of the Franchisee.</li>
         
 </ol>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          3. RIGHTS OF THE COMPANY :
        </h2>
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
          <li>The Customer represents and warrants that he shall not engage in any transaction directly and indirectly using the App for any commercial purpose that shall involve resale and/or direct commercial exploitation of the Purchased Items.</li>

          <li>Notwithstanding anything contained herein or any other document for the time being in force, time is not of the essence to any of the Definitive Documentation.
</li>

          <li> Any representation, warranty, covenants and/or declaration, whether express and/or implied, which is made by any third party shall not be deemed in any manner whatsoever a representation, warranty, covenants and/or declaration by the Company in any manner whatsoever
</li>

          <li> The Company represents and warrants that it has paid all applicable duties and taxes that are applicable to the Company in relation to retail sale of the Purchased Item
</li>

          <li> None of the transactions envisaged under the Definitive Documentation shall constitute a violation of the Essential Commodities Act, 1955.
</li>

          <li> The Company does not guarantee that the App, and/or any connected computer system/network/service connected thereto, will function on any particular hardware or devices. In addition, all the services envisaged under this Terms of Use rendered by the Company may be subject to malfunctions and delays inherent to the use of the Internet and electronic communications, including but not limited to location tracking services.
</li>

          <li>Notwithstanding anything contained herein, the Company disclaims all implied covenants, representations and warranties
</li>

          <li> Notwithstanding anything contained herein, it is expressly stated that the Company makes no representation, warranty, or guarantee regarding the reliability, timeliness, quality, suitability, or availability of the App, or that the services provided therein shall be uninterrupted or error-free.
</li>

          <li> If the Company decides to change this Terms of Use, the Company may notify such changes to the Customer through its App. However, the Company may only notify the Customer about those alterations that shall have a direct impact to his/her functionality, interaction and usage of the App.
</li>

          <li> In lieu of the services and the goods provisioned in accordance with these Terms, the Customer shall pay all such amounts as laid down in <span className="font-semibold">www.synergyteletech.com</span> as good consideration for the same.
</li>

          <li> The Company does not make any express and/or implied representation in relation to any Order to be delivered within a prescribed time limit. The duration of the Delivery Stage shall be communicated to the Customer through the App. For clarification of doubt, time is not of the essence to this Agreement.</li>

 </ol>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          4. EFFECTIVE DATE :
        </h2>
        
         <p className="text-gray-600 mb-6">
         
          The Effective Date of this Terms of Use shall be the date at which the Purchased Item are purchased by the Customer.
        </p>

        <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          5. INDEMNIFICATION :
        </h2>
<p className="text-gray-600 mb-6">
        The Customer shall defend, protect, indemnify and hold harmless the Company and its directors, employees, agents, successors, and assigns (“Indemnified Parties”) from and against any and all claims in connection therewith (collectively, the “Indemnified Liabilities”), incurred by the Indemnified Parties as a result of, arising out of or relating to:</p>
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
         <li> any misrepresentation by the Customer to the Indemnified Parties,</li>
         <li> any misrepresentation of the Customer to any Third Party, with respect to the Indemnified Parties,</li>
         <li> any Event of Default</li>
         <li> all applicable taxes for which the Customer may be liable and
The right of indemnification under this Clause 5 is not prejudicial to any other rights of the Indemnified Parties under this Agreement, Applicable Law, and/or equity.</li>

 </ol>

  <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          6. LIMITATION OF LIABLITY :
        </h2>
<p className="text-gray-600 mb-6">
        The aggregate liability of the Company under this Terms of Use with respect to any of the transactions envisaged herein shall be limited to maximum retail price of the Purchased Items which are subject matter of such a transaction, which shall be interest free, and does not include any consequential and/or incidental damages.</p>

 <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          7. GOVERNING LAW AND ARBITRATION :
        </h2>
<ol className="list-decimal pl-6 space-y-2 text-gray-600">
         <li> This Terms of Use and its performance shall be governed by and construed in all respects in accordance with the Laws of the Republic of India.</li>
       

<li> This Terms of Use shall be subject to the jurisdiction of the courts in Gurgaon, India</li>
</ol>

<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          8. TERMINATION :
        </h2> 
        <p className="text-gray-600 mb-6">The Company shall have a right but not an obligation to terminate its engagement with the Customer on the occurrence of an Event of Default.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          9. SURVIVAL :
        </h2> 
        <p className="text-gray-600 mb-6">Clauses 5, 6, 7, 8 and 10 and all the definitions associated thereto (whether under this Terms of Use, under Applicable Law, standard industry practices or otherwise) shall survive the termination of this Terms of Use and/or the engagement with the Customer.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          10. ASSIGNABILITY :
        </h2> 
        <p className="text-gray-600 mb-6">Except as provided in this Terms of Use, neither Party, shall be entitled to assign their rights and obligations under the Terms of Use to a Third Party without the prior written consent of the other Parties. The Parties shall execute such documents as may be necessary or desirable to give effect to such assignment.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          11. CONFIDENTIALITY :
        </h2> 
        <p className="text-gray-600 mb-6">It is hereby clarified that nothing contained herein shall affect the ability of the Company to make disclosure to any governmental authority or any other Person under the provisions of any Applicable Law, and/or the ability of the Company to make disclosures to its lenders, third party contractors and/other associated entities.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          12. SEVERABILITY :
        </h2> 
        <p className="text-gray-600 mb-6">
Any provision in this Terms of Use, which is or may become prohibited or unenforceable in any jurisdiction, shall, as to such jurisdiction, be ineffective to the extent of such prohibition or unenforceability without invalidating the remaining provisions of this Terms of Use or affecting the validity or enforceability of such provision in the same or any other jurisdiction. Without prejudice to the foregoing, the Parties will immediately negotiate in good faith to replace such provision with a proviso, which is not prohibited or unenforceable and has, as far as possible, the same legal and commercial effect as that which it replaces.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
         13. INDEPENDENT CONTRACTORS :
        </h2> 
        <p className="text-gray-600 mb-6">
The Parties are independent contracting parties and will have no power or authority to assume or create any obligation or responsibility on behalf of each other. This Terms of Use will not be construed to create or imply any partnership, agency or joint venture, or employer-employee relationship.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
        14. SUPPORT :
        </h2> 
        <p className="text-gray-600 mb-6">
In case the Customer faces any issues, he can reach out to <span className="font-semibold">support@synergyteletech.com</span></p>

<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
        15. CANCELLATION POLICY :
        </h2> 



<ol className="list-decimal pl-6 space-y-2 text-gray-600"><li>The Customer is allowed to cancel Orders which have not reached Delivery Stage and the refunds shall processed within a reasonable period of time.</li><li>Notwithstanding anything contained herein, no refunds shall be processed to Orders which are cancelled after they have reached Delivery Stage.</li></ol>


<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
        16. ENTIRE AGREEMENT :
        </h2> 
        <p className="text-gray-600 mb-6">
This Terms of Use along with the other Definitive Documentation comprise the entire agreement of the Parties hereto with respect to the transactions envisaged under this Terms of Use and Annexures attached thereto and the inter-se rights and obligations of the Parties, superseding and replacing all prior negotiations, agreements, discussions, memoranda or heads of agreements. For clarification of doubt, it is expressly stated that the Recitals form an inherent part of this Terms of Use.</p>




 





















      </div>
    </div>

    {/* Footer with Close Button */}
    <div className="flex justify-center p-4 border-t bg-gray-50">
      <button
        onClick={() => setIsOpen4(false)}
        className="px-6 py-2 bg-yellow-600 text-white rounded-lg font-medium hover:bg-yellow-700 transition-colors"
      >
        Close
      </button>
    </div>
  </div>
</div>
      )}
      {/* Modal Overlay 5 */}
       {isOpen5 && (
        <div
  className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  role="dialog"
  aria-modal="true"
  aria-labelledby="terms-title"
>
  <div className="bg-white rounded-lg shadow-xl w-[70%] h-[100%] flex flex-col overflow-hidden">
    
    {/* Scrollable Body */}
    <div className="flex-1 overflow-y-auto p-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        
        {/* Title */}
        <h1 id="terms-title" className="text-3xl font-bold text-gray-800 mb-6">
         FUEL QUALITY AGREEMENT
        </h1>

        {/* Intro */}
       
        
          <span className="text-gray-600 mb-10 font-semibold">  PLEASE READ THIS STATEMENT CAREFULLY BEFORE USING THE PURCHASED ITEM. YOUR USE OF THIS PURCHASE ITEM SHALL CONSTITUTE YOUR ACCEPTANCE OF FUEL QUALITY AGREEMENT. IF YOU DO NOT ACCEPT THESE TERMS OF THIS AGREEMENT, DO NOT USE THE PURCHASED ITEM AND/OR DO NOT SUBSCRIBE TO THE SERVICE. </span> 
       
 <p className="text-gray-600 mb-6">
The Fuel Quality Agreement (“Agreement”) is entered into by and between Synergy Teletech Private Limited (hereinafter referred to as “Company”) and the Consumer (herein after referred to as “User”). This Agreement governs the terms and conditions of the User’s use of the purchased item (“Fuel”).
        </p>

        {/* WHEREAS Section */}
        <h2 className="text-xl font-semibold text-gray-700 mb-4">WHEREAS:</h2>
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
          <li> The Company is engaged in the business of sale and delivery of Biodiesel, branded as Synergy Green Diesel or aggregating demand for delivery of HSD (High Speed Diesel) (hereinafter referred to “Fuel”) to customers through its franchisee network.
 </li>
          <li>The User is the end consumer and/or the customer of the Company who is using the Service for personal consumption.</li>
          <li>The Parties are desirous to enter into this Agreement.</li>
          <li>In consideration of the mutual promises, covenants, undertakings and agreements between the Parties hereto, the Parties hereby enter into this Agreement on the terms and conditions contained herein.</li>
        </ol>
 <p className="text-gray-600 mb-6">
By using the Fuel, the User acknowledge that the User have read, understand, acknowledge and agree to be bound by all the terms and conditions of this Agreement and any new, different, or additional terms or conditions that the Company may establish from time to time at its sole discretion.
        </p>
        {/* Definitions Section */}
       

        {/* Customer Representations */}
        <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          1. DEFINITIONS AND INTERPRETATION :
        </h2>
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
         
         
        <li>
 <span className="font-semibold">Definitions : </span>The Parties (namely Synergy Teletech Private Limited and the User) to this Agreement hereby unconditionally agree that unless the context otherwise requires, the terms listed below when used in this Agreement shall have the meanings attached to them and these terms shall be interpreted accordingly. The terms listed below as used in this Agreement may be identified by the capitalization of the first letter of each principal word thereof:
“Company Delivery Agent” shall mean the authorised representative of the Company carrying out the Delivery of the Fuel.

“Delivery Date” shall mean the actual date of delivery of the Fuel.

“Force Majeure” shall include any and all acts, events, omissions or accidents beyond reasonable control, including strikes, lockouts or other industrial disputes (whether involving the workforce of the Company or any other party), failure of a utility service or transport network, act of God, war, riot, civil commotion, malicious damage, compliance with any law or governmental order, rule, regulation or direction, accident, breakdown of plant or machinery, fire, flood, storm or default of suppliers or subcontractors.

“Manufacturing Defect” shall be mean any deviation from the intended specifications of the Fuel more specifically described in Annexure A.

“Purchase Date” shall be the date of purchase of the Fuel and shall be the date on which the payment for the Fuel of the User is successfully processed.

“Third-Party Partners” shall include any and all persons, body corporates and/or entities with whom the Company has entered into a contract with any and all matters which are connected to the Service either directly or indirectly.

“User” shall include any legal natural person using the Fuel, service, website and/or App provided by the Company.

“Sampling” shall mean the process of quality assessment of the Fuel by the User to ascertain if there exists a Manufacturing Defect in the presence of Company Delivery Agent.

“Warranty Claim” shall have the meaning ascribed to it in Clause 5.2.
</li>
        <li>
  <span className="font-semibold">General Interpretation : In this Agreement, except that the context otherwise requires: </span> </li> <li> References to a statute, ordinance or other Law shall be deemed to include any references to a statute, ordinance or other Law as amended, supplemented or replaced from time to time in accordance with its terms and (where applicable) subject to compliance with the requirements set forth therein and shall include regulations and other instruments under such statute, ordinance or other Law.</li>
        <li>
  References to Clauses, are reference to clauses in this Agreement unless the context requires otherwise and the recitals to this Agreement shall always be deemed to form part of this Agreement.</li>
        <li>
  The headings are inserted for convenience only and shall not affect the construction of this Agreement .</li>
        <li>
  The masculine gender includes the feminine gender as well as the neuter.</li>
        </ol>

 <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          2. EFFECTIVE DATE : The Effective Date of this Agreement shall be the Purchase Date.
        </h2>
       
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          3. GENERAL CONDITIONS, COVENANTS, REPRESENTATIONS, WARRANTIES AND DECLARATIONS
        </h2>
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
          <li>Other than at the instance of a Manufacturing Defect, the Company does not make any implied or express covenant in relation to the quality and merchantability of the Fuel as well as it being error free.</li>

          <li>The User understands, acknowledges, affirms and agrees that the conditions which are specific to the User in the terms of use applicable to the FillNow mobile application are applicable mutatis mutandis to this Agreement and both the agreements need to interpreted using the principle of harmonious construction. At the instance of a direct conflict however, the terms governing the mobile application shall prevail.
</li>

          <li> Notwithstanding anything contained herein, the Company does not warrant for the functioning of the Fuel to meet the any expectation and/or criteria which have not been specifically laid herein in this Agreement.
</li>

          <li> Notwithstanding anything contained herein, the Company specifically disclaims any implied representations, warranties, declarations and covenants in relation to the Fuel and any functionality thereof.
</li>

          <li> None of the transactions envisaged under the Definitive Documentation shall constitute a violation of the Essential Commodities Act, 1955.
</li>

          <li> The User shall take no steps in attempting to reverse engineer the Fuel and/or any associated technologies thereto. The User understands that the Company is induced to enter into a transaction with the User to deliver the Fuel on the basis of, inter alia mentioned in this Agreement or otherwise, the declaration made in this Clause 4.7 by the User.
</li>

          <li>Subject to Clause 4, the Company warrants that the Fuel will perform in accordance with the specifications provided by the Company to the User more specifically described in Annexure A.
</li>

          <li> Subject to applicable law, the User specifically disclaims any and all rights under this contract or law for direct, indirect, incidental, special, consequential or exemplary damages, including but not limited to, damages for loss of profits, goodwill, use, data or other intangible losses (even if the Company has been advised of the possibility of such damages), resulting from: (i) the use or the inability to use the Fuel; (ii) unauthorized access to or alteration of User’s transmissions or data; (iii) statements or conduct of any third party on the Fuel and the corresponding services; (iv) or any other matter relating to the Fuel and the corresponding services not specifically laid down herein (v) any Manufacturing Defect, as against the Company.
</li>

         

 </ol>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          4. FUEL WARRANTY :
        </h2>
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
         
         
        <li>The Company extends a limited, revocable, non-transferable warranty from the Purchase Date to the Date of Delivery in relation to the Fuel (“Fuel Warranty”) at the instance any Manufacturing Defect is found during the process of Sampling.</li>
        <li>Notwithstanding anything contained</li>
        <li>At the instance the User wants to assert the Fuel Warranty, he needs to communicate to the Company (“Warranty Claim”) immediately after the process of Sampling in the presence of the Company Delivery Agent. For clarification of doubt, all Manufacturing Defects shall be deemed to have arisen as on the date of any Warranty Claim.</li>
        <li>In the event of a Warranty Claim, the Company shall replace the Fuel. In the event that the Company fails to replace the Fuel within a reasonable period, the User’s sole recourse shall be to terminate the Agreement. In no event shall the Company be liable for any incidental, consequential, or punitive damages as a result of its performance or breach of this Clause, including but not limited to any vehicular damage.</li>
        <li>Notwithstanding anything contained herein, the Fuel Warranty shall become void and/or inapplicable at the following instances:</li>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li> If the User enters into any insurance/warranty agreement with any third party in relation to the Fuel without the consent of the Company.</li>
          <li>In case of any damage caused which does not directly arise from a Manufacturing Defect.</li>
          <li>Any deviation in the Fuel which is not the subject matter of the specifications mentioned in Annexure A.</li>
          <li> In case of any breakage or damage of the Fuel and/or disruption of the corresponding services of the Company due to any direct and/or indirect actions and/or omissions of the User.</li>
          <li> Any defects and/or deficiency of service caused by any third party as envisaged under Clause 3.1 of this Agreement.</li>
          <li> In case of the Force Majeure event.</li>
        </ul>


        <li>For clarification of doubt, the Fuel Warranty is limited to any Manufacturing Defects and the User is not entitled and specifically disclaims to any other warranties, express or implied, that may arise either by agreement between the parties or by operation of law as against the Company.</li>
        </ol>
        

        <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          5. LIMITATION OF LIABILITY :
        </h2>
<p className="text-gray-600 mb-6">
       UNDER NO CIRCUMSTANCES SHALL THE COMPANY, OR THEIR RESPECTIVE PARENTS, AFFILIATES, DIRECTORS, EMPLOYEES, DISTRIBUTORS, SUPPLIERS, AGENTS OR RESELLERS BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY DAMAGES, OR DAMAGES FOR LOSS OF BUSINESS, LOSS OF PROFITS, BUSINESS INTERRUPTION, OR LOSS OF BUSINESS INFORMATION THAT RESULT FROM THE USE OF, OR INABILITY TO USE, THE FUEL, AND IN NO EVENT SHALL COMPANY’S LIABILITY TO THE CUSTOMER FOR ALL DAMAGES. THIS LIMITATION APPLIES WHETHER THE ALLEGED LIABILITY IS BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR ANY OTHER BASIS, EVEN IF THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. ADDITIONALLY, UNDER NO CIRCUMSTANCES SHALL COMPANY BE HELD RESPONSIBLE OR LIABLE, DIRECTLY OR INDIRECTLY, FOR ANY LOSS OR DAMAGE CAUSED OR ALLEGED TO HAVE BEEN CAUSED TO THE USER IN CONNECTION WITH THE USE OF OR RELIANCE ON ANY CONTENT, GOODS OR SERVICES AVAILABLE ON OR THROUGH ANY EXTERNAL SITES LINKED FROM THE APP. COMPANY IS NOT RESPONSIBLE FOR, AND SHALL HAVE NO LIABILITY FOR, THE LOSS OF OR DAMAGE TO THE USER’S CONTENT AND DOCUMENTS INCLUDING ANY LOSS OR DAMAGE RESULTING FROM NON-FUNCTIONALITY OF THE FUEL AND/OR THE SUSPENSION OR TERMINATION OF THE LICENSED APP OR THIS AGREEMENT.

NOTWITHSTANDING ANYTHING CONTAINED HEREIN, THE LIABILITY OF COMPANY TO THE USER (ALONG WITH ITS PERMITTED ASSIGNS, AGENTS, EMPLOYEES, HEIRS, SUCCESSORS AND/OR AUTHORISED REPRESENTATIVES) SHALL NOT BE MORE THAN TOTAL COST OF THE FUEL, INTEREST FREE, RECEIVED FROM THE USER UNDER THIS AGREEMENT AT ANY GIVEN INSTANCE.</p>
        

  <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          6. DISPLAY, USE OF INFORMATION AND PRIVACY POLICY :
        </h2>
<p className="text-gray-600 mb-6">
       Refer for the other Legal Documentation of the Company provided for in the App and/or the Website link- www.fillnow.in
</p>

 <h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          7. CANCELLATION OR TERMINATION :
        </h2>
<ol className="list-decimal pl-6 space-y-2 text-gray-600">
         <li> The Company may, at any time, terminate this Agreement or disable or take down any information displayed at the instance of a breach of any and all obligations by the User under this Agreement and/or any other legal documentation that is entered into by and between the Company and the User.</li>
       

<li>The Company reserves the right to immediately terminate this Agreement without prior notice if the User’s use of the Fuel results in, or is the subject of, legal action or threatened or proposed legal action, against the Company or any of its affiliates, without consideration of whether such legal action or threatened or proposed legal action is eventually determined to be with or without merit.</li>
<li> At the instance of termination of this Agreement by the Company in accordance with this Clause 7, the corresponding Fuel Warranty shall stand lapsed as on the date of such termination. </li>
</ol>

<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          8. INDEMNIFICATION :
        </h2> 
               <ol className="list-decimal pl-6 space-y-2 text-gray-600">
                <li> The User shall defend, protect, indemnify and hold harmless the Company and its directors, employees, agents, successors, and assigns (“Indemnified Parties”) from and against any and all claims in connection therewith (collectively, the “Indemnified Liabilities”), incurred by the Indemnified Parties as a result of, arising out of or relating to:</li>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li> any misrepresentation by the User to the Indemnified Parties,</li>
                  <li>any misrepresentation of the User to any Third Party, with respect to the Indemnified Parties,</li>
                  <li>any direct, incidental and consequential losses suffered by the Company due to any of the actions carried out by the End User with the Fuel or otherwise.</li>
                </ul>
                <li>The right of indemnification under this Clause 9 is not prejudicial to any other rights of the Indemnified Parties under this Agreement, applicable law, and/or equity.
</li>
                <li> The right of indemnification under this Clause 9 is not prejudicial to any other rights of the Indemnified Parties under this Agreement, applicable law, and/or equity.</li>
</ol>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          9. JURISDICTION AND DISPUTES :
        </h2> 
        <ol className="list-decimal pl-6 space-y-2 text-gray-600">
                <li>  This Agreement and its performance shall be governed by and construed in all respects in accordance with the Laws of the Republic of India.</li>
                <li>Subject to Clause 9.3 below, this Agreement shall be subject to the jurisdiction of the courts in Bangalore, India.</li>
                <li>Any action, Dispute or difference arising under or relating to this Agreement (“Dispute”) shall at the first instance be resolved through good faith negotiations between the Parties hereto, which negotiations shall begin promptly, within 15 (fifteen) days after a Party has delivered to the other Party a written request for such consultation. If the Parties are unable to resolve the Dispute in question within 15 (fifteen) days of the commencement of negotiations, the Dispute shall be referred to and finally and conclusively settled by arbitration in accordance with the Indian Arbitration and Conciliation Act, 1996.</li>
                <li>The seat as well as the venue of arbitration at all times shall be Gurgaon, India.</li>
                <li>All proceedings, including issuance of an arbitration award, in any such arbitration, shall be conducted in English.</li>
                <li>The arbitration shall be conducted by a tribunal of 3 (three) arbitrators. The Parties agree that the User shall appoint 1 (one) arbitrator, the Company shall appoint 1 (one) arbitrator and the arbitrators so appointed shall appoint the third arbitrator.</li>
                <li>The arbitral tribunal will have the power to grant any remedy or relief that they deem just and equitable, including but not limited to injunctive relief, whether interim and/or final.</li>
                <li>The arbitration award shall be final and binding on the Parties and may be enforced by any court of competent jurisdiction.</li>
                <li>The Parties agree to bear their own costs of arbitration until such time that the arbitral tribunal does not pass an award deciding on the costs. The arbitrators may, (but shall not be required to), award to a Party that substantially prevails on merits, its costs and reasonable expenses (including reasonable fees of its counsel).</li>
                <li>When any Dispute is under arbitration, the Parties shall continue to exercise their remaining respective rights and fulfil their remaining respective obligations under this Agreement.</li>
                </ol>
       
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          10. AMENDMENTS AND WAIVER :
        </h2> 
        <p className="text-gray-600 mb-6">Any provision of this Agreement may be amended or waived. No waiver by any Party of any term or condition of this Agreement, in any one or more instances, shall be deemed to be or construed as a waiver of the same or any other term or condition of this Agreement on any future occasion. All remedies, either under this Agreement or by Law or otherwise afforded, will be cumulative and not alternative.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          11. INDEPENDENT CONTRACTORS :
        </h2> 
        <p className="text-gray-600 mb-6">The Company and User are independent contracting parties and will have no power or authority to assume or create any obligation or responsibility on behalf of each other. This Agreement will not be construed to create or imply any partnership, agency or joint venture, or employer-employee relationship.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
          12. SEVERABILITY :
        </h2> 
        <p className="text-gray-600 mb-6">
If any provision hereof is held invalid or unenforceable by any court of competent jurisdiction, such invalidity shall not affect the validity or operation of any other provision and such invalid provision shall be deemed to be severed from the Agreement.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
         13. ENTIRE AGREEMENT :
        </h2> 
        <p className="text-gray-600 mb-6">
This Agreement, the terms of use, the data protection documentation and offer terms are the entire agreement between the Company and User with respect to the transactions envisaged herein and the inter-se rights and obligations of the Parties, superseding and replacing all negotiations, prior agreements, discussions, memoranda or heads of agreements, made prior to the date hereof amongst the Company and User. For clarification of doubt, the recitals to this Agreement form an integral part of this Agreement.</p>
<h2 className="text-xl font-semibold text-gray-700 mt-8 mb-4">
        14. CONTACT US :
        </h2> 
        <p className="text-gray-600 mb-6">
Anything pertaining to this agreement, please contact our grievance redressal officer by sending an e-mail to <span className="font-semibold">info@synergyteletech.com</span> .</p>


      </div>
    </div>

    {/* Footer with Close Button */}
    <div className="flex justify-center p-4 border-t bg-gray-50">
      <button
        onClick={() => setIsOpen5(false)}
        className="px-6 py-2 bg-yellow-600 text-white rounded-lg font-medium hover:bg-yellow-700 transition-colors"
      >
        Close
      </button>
    </div>
  </div>
</div>
      )}


      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
        {/* Logo Section */}
       

        {/* <div className="text-center sm:text-left">
  <div className="inline-block bg-white rounded-lg shadow-lg p-1">
 <img
  src={Final}
  alt="Synergy Logo"
  className="h-36 mx-auto sm:mx-0 mb-4 p-2 rounded-xl bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 shadow-xl"
/>
     <p className="text-sm">&copy; 2025 Synergy Teletech Private Limited</p>
          <p className="text-sm">All Rights Reserved</p>
  </div>
</div> */}
<div className="inline-flex items-center justify-center h-44 w-44 rounded-full bg-white shadow-2xl ring-4 ring-blue-400">
<img
  src={Final}
  alt="Synergy Logo"
  className="h-36 mx-auto sm:mx-0 mb-4 drop-shadow-[0_0_15px_rgba(59,130,246,0.8)]"
/>

</div>

        {/* Product Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Product</h3>
          <ul className="space-y-2">
            <li><NavLink to="/synergy-dg" className="text-sm hover:text-orange-400"> Compressed Bio Gas</NavLink></li>
            <li><NavLink to="/synergy-organic-fertilizer" className="text-sm hover:text-orange-400"> Organic Fertilizer</NavLink></li>
            <li><NavLink to="/synergy-fabrication" className="text-sm hover:text-orange-400"> Fabrication Services</NavLink></li>
            <li><NavLink to="/synergy-def-dispenser" className="text-sm hover:text-orange-400"> DEF Dispenser</NavLink></li>

            <li><NavLink to="/it-automation" className="text-sm hover:text-orange-400"> IT & Automation</NavLink></li>
          </ul>
        </div>

        {/* Links Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Links</h3>
          <ul className="space-y-2">
            <li>
             <button
        onClick={() => setIsOpen(true)}
        className="text-sm hover:text-orange-400"
      >
Privacy Policy</button></li>

            <li> <button
        onClick={() => setIsOpen2(true)}
        className="text-sm hover:text-orange-400"
      >
Shipping Policy</button></li>
  <li> <button
        onClick={() => setIsOpen3(true)}
        className="text-sm hover:text-orange-400"
      >
Refunds/Cancellations</button></li>
  <li> <button
        onClick={() => setIsOpen4(true)}
        className="text-sm hover:text-orange-400"
      >
Terms and Conditions</button></li>
  <li> <button
        onClick={() => setIsOpen5(true)}
        className="text-sm hover:text-orange-400"
      >
Fuel Quality Agreement</button></li>
          </ul>
        </div>

        {/* Contact Us Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
          <ul className="space-y-3">
            <li className="flex items-center space-x-2">
  <FaPhoneAlt className="text-green-500 text-xl" />
  <div className="flex flex-col">
    <a href="tel:+918686062620" className="text-sm hover:underline">
      +91-86860 62620
    </a>
    <a href="tel:+918686062621" className="text-sm hover:underline">
      +91-86860 62621
    </a>
  </div>
</li>

            <li className="flex items-center space-x-2">
              <FaEnvelope className="text-red-500 text-xl" />
              <a href="mailto:info@synergyteletech.com" className="text-sm">info@synergyteletech.com</a>
            </li>
          </ul>

          {/* Social Icons */}
          <div className="mt-6 flex justify-center sm:justify-start space-x-4">
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
              <FaXTwitter className="text-black hover:text-gray-700 text-2xl" />
            </a>
            <a href="https://www.facebook.com/synergyteletech/" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="text-blue-600 hover:text-blue-800 text-2xl" />
            </a>
            <a href="https://www.instagram.com/synergyteletech/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="text-pink-500 hover:text-pink-700 text-2xl" />
            </a>
            <a href="https://www.linkedin.com/company/synergy-teletech-private-limited/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="text-blue-700 hover:text-blue-900 text-2xl" />
            </a>
          </div>
        </div>

        {/* Download App Section */}
        {/* <div className="w-auto">
          <h3 className="text-lg font-semibold mb-4">Download the App</h3>
          <div className="flex justify-center sm:justify-start items-center gap-4">
            <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
              <img src={PlayStore} alt="Google Play Store" className="h-20 object-contain" />
            </a>
            <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
              <img src={AppStore} alt="Apple App Store" className="h-20 object-contain" />
            </a>
          </div>
        </div> */}
      </div>

      {/* Footer Bottom Section */}
      <div className="mb-[-25px] pt-2 mt-2 border-t border-gray-500 text-center text-sm w-full ">
    <p>&copy; 2025 Synergy Teletech Private Limited. All Rights Reserved.</p>
  </div>
    </footer>
  );
};

export default Footer;
